/**
 * Token store. Operator access/refresh tokens are module-scoped and never
 * persisted (a reload returns to the shift lock screen). The *device* token is
 * persisted in localStorage: it binds the physical terminal to its station and
 * must survive reloads and shift changes.
 */

const DEVICE_TOKEN_KEY = "awtoban.device_token";

let accessToken: string | null = null;
let refreshToken: string | null = null;
let listeners = new Set<(token: string | null) => void>();

export function getDeviceToken(): string | null {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(DEVICE_TOKEN_KEY);
}

export function setDeviceToken(token: string | null): void {
  if (typeof window === "undefined") return;
  if (token) window.localStorage.setItem(DEVICE_TOKEN_KEY, token);
  else window.localStorage.removeItem(DEVICE_TOKEN_KEY);
}

/** Clear only the operator shift session (keeps the device binding). */
export function clearOperatorSession(): void {
  refreshToken = null;
  setAccessToken(null); // notifies listeners
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  if (accessToken === token) return;
  accessToken = token;
  for (const l of listeners) l(token);
}

export function getRefreshToken(): string | null {
  return refreshToken;
}

export function setRefreshToken(token: string | null): void {
  refreshToken = token;
}

export function subscribeToken(listener: (token: string | null) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function resetTokens(): void {
  refreshToken = null;
  setAccessToken(null);
  listeners = new Set();
}
